module.exports = __webpack_public_path__ + "static/img/suyang02.2de2abe9.jpg";